import React, { Fragment } from 'react'
import Footer from '../../component/Other/Footer'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import SecContact from '../../component/Page/SecContact'

const Team = () => {
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"Our Team"} to={"Our Team"} />
                </div>

                <section className="position-relative">
                    <div className="container">
                        <div className="text-center mb-5">
                            <h3 className='normal font__size--50 text__50-1024 text__50-sm text__50-xs quest'>Meet Our Happy People!</h3>
                            <p className="normal font__size--14 text__14-1024 color__gray-1">At Bloom & Grow, we have a dedicated team of plant enthusiasts who are passionate about providing the best possible products and services <br /> to our customers. Our team members come from diverse backgrounds and bring a wealth of knowledge and experience to the table.</p>
                        </div>

                        <div className="mb__5 position-relative">
                            <img src="./../images/Clip path group.png" className='d-none d-md-block images__or-1' alt="" />
                            <div className="row justify-content-center">
                                <div className="col-md-5 mb-4 my-md-auto">
                                    <div className="text-center">
                                        <img src="./../images/ssy (1).png" className='mb-3' alt="" />
                                        <h5 className='semi-bold font__size--24 text__24-1024'>Jane Doe</h5>
                                        <p className='normal font__size--14 text__14-1024 color__gray-1'>Plant Specialist</p>
                                    </div>
                                </div>
                                <div className="col-md-5 my-auto">
                                    <div>
                                        <img src="./../images/tikk.png" className='mb-4' alt="" />
                                        <p className='medium font__size--24 text__24-1024 lh__4'>I love working at Bloom & Grow because I get to share my passion for plants with customers every day. It's so rewarding to see their faces light up when they find the perfect plant for their home or office.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mb__5 position-relative">
                            <div className="row justify-content-center">
                                <div className="col-md-5 order-md-1 order-12 my-auto">
                                    <div>
                                        <img src="./../images/tikk.png" className='mb-4' alt="" />
                                        <p className='medium font__size--24 text__24-1024 lh__4'>At Bloom & Grow, we really care about our customers and making sure they have a great experience. I'm proud to be a part of a team that puts people first</p>
                                    </div>
                                </div>
                                <div className="col-md-5 order-1 order-md-12 mb-4 my-md-auto">
                                    <div className="text-center">
                                        <img src="./../images/ssy (2).png" className='mb-3' alt="" />
                                        <h5 className='semi-bold font__size--24 text__24-1024'>John Smith</h5>
                                        <p className='normal font__size--14 text__14-1024 color__gray-1'> Customer Service Manager</p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="mb__5 position-relative">
                            <img src="./../images/Clip path group 2.png" className='d-none d-md-block images__or-2' alt="" />
                            <div className="row justify-content-center">
                                <div className="col-md-5 mb-4 my-md-auto">
                                    <div className="text-center">
                                        <img src="./../images/ssy (3).png" className='mb-3' alt="" />
                                        <h5 className='semi-bold font__size--24 text__24-1024'>Michael Chen</h5>
                                        <p className='normal font__size--14 text__14-1024 color__gray-1'>Operations Manager</p>
                                    </div>
                                </div>
                                <div className="col-md-5 my-auto">
                                    <div>
                                        <img src="./../images/tikk.png" className='mb-4' alt="" />
                                        <p className='medium font__size--24 text__24-1024 lh__4'>I'm constantly impressed by the dedication and hard work of my colleagues at Bloom & Grow. It's a great feeling to be a part of such a driven team.</p>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div className="mb__5 position-relative">
                            <img src="./../images/Clip path group.png" className='d-none d-md-block images__or-3' alt="" />
                            <div className="row justify-content-center">
                                <div className="col-md-5 order-md-1 order-12 my-auto">
                                    <div>
                                        <img src="./../images/tikk.png" className='mb-4' alt="" />
                                        <p className='medium font__size--24 text__24-1024 lh__4'>Bloom & Grow is a company that truly values creativity and innovation. I love that I get to come up with new ideas and campaigns to help our business grow</p>
                                    </div>
                                </div>
                                <div className="col-md-5 order-1 order-md-12 mb-4 my-md-auto">
                                    <div className="text-center">
                                        <img src="./../images/ssy (4).png" className='mb-3' alt="" />
                                        <h5 className='semi-bold font__size--24 text__24-1024'>Parry Lee</h5>
                                        <p className='normal font__size--14 text__14-1024 color__gray-1'> Marketing Coordinator</p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="mb__5 position-relative">
                            <img src="./../images/Clip path group 2.png" className='d-none d-md-block images__or-4' alt="" />
                            <div className="row justify-content-center">
                                <div className="col-md-5 mb-4 my-md-auto">
                                    <div className="text-center">
                                        <img src="./../images/ssy (5).png" className='mb-3' alt="" />
                                        <h5 className='semi-bold font__size--24 text__24-1024'>David Kim</h5>
                                        <p className='normal font__size--14 text__14-1024 color__gray-1'>Web Developer</p>
                                    </div>
                                </div>
                                <div className="col-md-5 my-auto">
                                    <div>
                                        <img src="./../images/tikk.png" className='mb-4' alt="" />
                                        <p className='medium font__size--24 text__24-1024 lh__4'>I'm really proud of the website we've built at Bloom & Grow. It's great to work for a company that values quality and attention to detail.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>

                <SecContact />

                <Footer />
            </div >
        </Fragment >
    )
}

export default Team